import { render, staticRenderFns } from "./QuantsCartPage.vue?vue&type=template&id=1f1a2272&scoped=true"
import script from "./QuantsCartPage.vue?vue&type=script&lang=ts"
export * from "./QuantsCartPage.vue?vue&type=script&lang=ts"
import style0 from "./QuantsCartPage.vue?vue&type=style&index=0&id=1f1a2272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1a2272",
  null
  
)

export default component.exports